import {
  GET_KNOWLEDGE_CATEGORIES,
  GET_KNOWLEDGE_CATEGORIES_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  knowledgeCategories: [],
}

const KnowledgeCategoriesList = (state = initialState, action) => {
  switch (action.type) {
    case GET_KNOWLEDGE_CATEGORIES:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_KNOWLEDGE_CATEGORIES_SUCCESS:
      state = {
        ...state,
        knowledgeCategories: action.payload.knowledgeCategories,
        loading: false,
        done: true,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default KnowledgeCategoriesList
